import { useCallback, useState } from 'react';
import type { WorkspaceSearchFull } from '@trinity/chat';
import {
  SearchResultsAllContext, SearchResultsBrandContext, SearchResultsDashboardContext, SearchResultsQuantAnalysesContext, SearchResultsDispatchContext, SearchResultsFileContext,
  SearchResultsFolderContext, SearchResultsResetContext,
  SearchResultsTranscriptContext,
  SearchResultsProjectContext,
} from './Context';
import type { SearchResultsContextState } from './interfaces';

export default function Results({ children }: ChildrenProps) {
  const [state, dispatch] = useState<SearchResultsContextState>(getInitialState());

  const reset = useCallback((_: WorkspaceSearchFull.SearchTab) => {
    // dispatch(prev => ({
    //   ...prev,
    //   [tab]: tab === 'all'
    //     ? {
    //       brands: null,
    //       projects: null,
    //       members: null,
    //       files: null,
    //       folders: null,
    //       transcripts: null,
    //     }
    //     : null,
    // }));
    dispatch(getInitialState());
  }, []);

  return (
    <SearchResultsDispatchContext.Provider value={dispatch}>
      <SearchResultsResetContext.Provider value={reset}>
        <SearchResultsAllContext.Provider value={state.all}>
          <SearchResultsFileContext.Provider value={state.files}>
            <SearchResultsFolderContext.Provider value={state.folders}>
              <SearchResultsBrandContext.Provider value={state.brands}>
                <SearchResultsDashboardContext.Provider value={state.dashboards}>
                  <SearchResultsQuantAnalysesContext.Provider value={state.quantanalyses}>
                    <SearchResultsTranscriptContext.Provider value={state.transcripts}>
                      <SearchResultsProjectContext.Provider value={state.projects}>
                        {children}
                      </SearchResultsProjectContext.Provider>
                    </SearchResultsTranscriptContext.Provider>
                  </SearchResultsQuantAnalysesContext.Provider>
                </SearchResultsDashboardContext.Provider>
              </SearchResultsBrandContext.Provider>
            </SearchResultsFolderContext.Provider>
          </SearchResultsFileContext.Provider>
        </SearchResultsAllContext.Provider>
      </SearchResultsResetContext.Provider>
    </SearchResultsDispatchContext.Provider>
  );
}

function getInitialState(): SearchResultsContextState {
  return {
    all: {
      files: null,
      folders: null,
      brands: null,
      dashboards: null,
      quantanalyses: null,
      transcripts: null,
      projects: null,
    },
    files: null,
    folders: null,
    brands: null,
    dashboards: null,
    quantanalyses: null,
    transcripts: null,
    projects: null,
  };
}

export { Results };